import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { NGXLogger } from 'ngx-logger'
import { type Observable } from 'rxjs'
import { DataService } from './data.service'
import { type HeaderResponseV2 } from '../models/header-footer.models'

export interface IHeaderFooterService {
  getHeaderFooterData: () => Observable<HeaderResponseV2>
}

@Injectable({
  providedIn: 'root'
})
export class HeaderFooterService implements IHeaderFooterService {
  private readonly apiUrl: string

  constructor (
    private readonly http: HttpClient,
    private readonly dataService: DataService,
    private readonly logger: NGXLogger,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.apiUrl = this.remoteConfigService.get('headerV2.baseUrl')
  }

  getHeaderFooterData (): Observable<HeaderResponseV2> {
    // return of(HEADER_FOOTER_RESPONSE_V2) // For testing with mock data
    return this.http.get<HeaderResponseV2>(this.apiUrl)
  }

  getHeaderFooter (): void {
    if (this.apiUrl) {
      this.getHeaderFooterData().subscribe(
        value => {
          this.dataService.headerFooterDataLoaded(value)
        },
        error => {
          this.logger.debug(error)
          this.dataService.headerFooterDataLoaded(null as unknown as HeaderResponseV2)
        }
      )
    }
  }
}
